import React, { Component } from 'react';

// eslint-disable-next-line global-require
const server = typeof window === 'undefined' && require('./server');

interface IServerBoundaryProps {
    fallBack: (e?: Error) => JSX.Element;
}

const ProvideContext = server && server.makeProvider({});

class ServerBoundary extends Component<IServerBoundaryProps> {

    static defaultProps = {
        fallBack: (): void => undefined,
    };

    static contextTypes = {};

    public readonly state = {
        hasError: false,
    };

    componentDidCatch(): void {

        this.setState({
            hasError: true,
        });
    }

    public render(): JSX.Element {
        if (server) return server.doRender(this, ProvideContext);
        return <div>{this.state.hasError ? this.props.fallBack() : this.props.children}</div>;
    }
}

export default ServerBoundary;
